import { useModalContext } from 'utils/contexts/modal/context';
import { RestoreTemplateModal } from './RestoreTemplateModal';
import type { TemplateHistoryModalState } from '../../types';

export const TemplateHistoryModals = () => {
  const { modalState, hideModal } = useModalContext<TemplateHistoryModalState>();
  if (modalState === null) return null;

  const { action } = modalState;

  switch (action) {
    case 'restoreTemplateModal':
      return (
        <RestoreTemplateModal
          newContent={modalState.newContent}
          onClose={hideModal}
          templateId={modalState.templateId}
        />
      );
    default:
      return null;
  }
};
